
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';
import Card from '../../components/base/Card';
import Header from '../../components/feature/Header';
import { authService } from '../../services/authService';

export default function ProfileSetup() {
  const [selectedType, setSelectedType] = useState<string>('');
  const navigate = useNavigate();

  const userTypes = [
    {
      id: 'student',
      title: 'Student',
      description: 'Looking for internships or entry-level positions',
      icon: 'ri-graduation-cap-line',
      color: 'bg-green-100 text-green-600'
    },
    {
      id: 'professional',
      title: 'Professional',
      description: 'Experienced professional seeking new opportunities',
      icon: 'ri-briefcase-line',
      color: 'bg-blue-100 text-blue-600'
    },
    {
      id: 'other',
      title: 'Other',
      description: 'Career changer or other background',
      icon: 'ri-user-line',
      color: 'bg-purple-100 text-purple-600'
    }
  ];

  const handleContinue = () => {
    if (selectedType) {
      authService.updateUserType(selectedType, JSON.parse(localStorage.getItem('user') || '{}').id);
      localStorage.setItem('userType', selectedType);
      navigate('/dashboard');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <Header showAuth={false} />

      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Tell us about yourself
          </h1>
          <p className="text-lg text-gray-600">
            This helps us customize your interview experience
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-8">
          {userTypes.map((type) => (
            <Card
              key={type.id}
              hover
              className={`text-center transition-all duration-200 ${selectedType === type.id
                ? 'ring-2 ring-blue-500 border-blue-200'
                : 'hover:border-gray-300'
                }`}
              onClick={() => setSelectedType(type.id)}
            >
              <div className={`w-16 h-16 ${type.color} rounded-full flex items-center justify-center mx-auto mb-4`}>
                <i className={`${type.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {type.title}
              </h3>
              <p className="text-gray-600">
                {type.description}
              </p>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Button
            onClick={handleContinue}
            disabled={!selectedType}
            size="lg"
            className="px-8"
          >
            Continue
            <i className="ri-arrow-right-line ml-2"></i>
          </Button>
        </div>
      </div>
    </div>
  );
}
